import axios from 'axios';
import auth from '@client/components/auth';
import { keys } from '../../../helpers/general';
import { F1 } from '../../../helpers/types';
import { FullMedia } from './GQLTypes';

type Endpoint<TIn, TOut> = { body: TIn; response: TOut };
type ApiEndpoints = {
  'admin-upload': Endpoint<{ media: File }, FullMedia>;
};

export type UploadParams = {
  removeAudio?: boolean;
  startTime?: number;
  duration?: number;
  thumbnailTimestamp?: number;
};

export const apiPost = <T extends keyof ApiEndpoints>(
  endpoint: T,
  body: ApiEndpoints[T]['body'],
  params: {
    onProgress: F1<number>;
    influencerId: number;
    editParams?: UploadParams;
  },
) => {
  const formData = new FormData();
  keys(body).forEach((key) =>
    formData.append(key.toLocaleString(), body[key] as string),
  );

  const url = `${import.meta.env.VITE_ADMIN_UPLOAD_BASE_URL}/` + endpoint;

  return axios
    .post<ApiEndpoints[T]['response']>(url, formData, {
      headers: {
        Authorization: auth.getToken(), // TODO: anti-pattern
      },
      params: { creatorId: params.influencerId, ...params.editParams },
      onUploadProgress: (p) =>
        params.onProgress
          ? params.onProgress(((p.loaded || 1) / (p.total || 1)) * 100)
          : null,
    })
    .then((response) => {
      if (response.status === 401) {
        throw new Error('auth');
      } else if (!response.data) {
        throw new Error('Network response error');
      }

      return response.data;
    });
};
